import Currency from '../_utils/tools/currency';
import { builderDispatch } from '../_utils/ui';
import CartItemsChangeEvents, {
  CartItemsAnalyticsEvents,
} from './cart-items-change-events';
import OrderCalculator from '../_utils/_order-data/order-calculator';

document.addEventListener('DOMContentLoaded', () => {
  if (typeof dataLayer === 'object') {
    dataLayer.push({
      cartId: App.order.order_id.replace(/^[A-Z]+/, ''),
    });
  }
});

builderDispatch.register(payload => {
  if (typeof dataLayer !== 'object') {
    return;
  }

  switch (payload.type) {
    case CartItemsChangeEvents.UPDATED:
      handleContentsChange(payload.items);
      break;
    case CartItemsChangeEvents.ZIP_CODE_CHANGED:
      handleZipCodeChanged(payload.value);
      break;
  }
});

// Product Item keys being pushed to the window dataLayer need to align with keys in
// https://github.com/livelink/web-kiosk/blob/main/app/google_tag_manager_data_layer/basket_page_google_tag_manager_data_layer.rb
// These are used within GTM for analytics etc

function handleContentsChange({ prints = {}, prism = [] }) {
  const items = [];
  let cartValue = 0;
  let printsDeliveryOption;
  (prints.delivery_options || []).forEach(option => {
    if (option.key == prints.delivery) {
      printsDeliveryOption = option.partner_id;
    }
  });

  OrderCalculator.alivePrintSizes(prints).forEach(size => {
    cartValue += size.total_price;

    items.push({
      catalog_item_id: size.partner_id,
      id: size.sku,
      category: 'Print',
      product_title: size.title,
      quantity: size.quantity,
      price: Currency.format(size.price),
      total_price: Currency.format(size.total_price),
      delivery_option: printsDeliveryOption,
    });
  });

  OrderCalculator.alivePrismItems(prism).forEach(item => {
    cartValue += item.cost;
    let deliveryOption;
    item.delivery_options.forEach(option => {
      if (option.key == item.delivery) {
        deliveryOption = option.partner_id;
      }
    });

    items.push({
      catalog_item_id: item.partner_id,
      id: item.sku,
      category: item?.product_category?.title,
      product_title: item.product_title,
      quantity: item.quantity,
      price: Currency.format(item.price),
      total_price: Currency.format(item.cost),
      delivery_option: deliveryOption,
    });
  });

  dataLayer.push({
    event: CartItemsAnalyticsEvents.UPDATED,
    cart_value: Currency.format(cartValue),
    items,
  });
}

function handleZipCodeChanged(value) {
  dataLayer.push({
    event: CartItemsAnalyticsEvents.UPDATED,
    zip_code: value,
  });
}
